// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgRight24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M10.5303 5.46967C10.2374 5.17678 9.76256 5.17678 9.46967 5.46967C9.17678 5.76256 9.17678 6.23744 9.46967 6.53033L14.939 12L9.46967 17.4697C9.2034 17.7359 9.1792 18.1526 9.39705 18.4462L9.46967 18.5303C9.76256 18.8232 10.2374 18.8232 10.5303 18.5303L16.5303 12.5303C16.8232 12.2374 16.8232 11.7626 16.5303 11.4697L10.5303 5.46967Z" />
			</Svg>
		);
	}
);
SvgRight24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgRight24;
